import React from 'react';
import styles from './PageTracker.module.css';

const PageTracker = ({ currentStep }) => {
  
  const steps = [
    { id: 1, label: 'Client Details' },
    { id: 2, label: 'Investments' },
    { id: 3, label: 'Protection & Liabilities' },
    { id: 4, label: 'Goals' }
  ];

  return (
    <div className={styles.trackerContainer}>
      <div className={styles.stepsWrapper}>
        {steps.map((step) => (
          <div 
            key={step.id} 
            className={`${styles.stepPill} ${step.id <= currentStep ? styles.active : styles.inactive}`}
          >
            <span>0{step.id} — {step.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PageTracker;
